<button class="btn-modal-icon-close" type="button" mat-icon-button mat-dialog-close>
	<bp-svg-icon name="close"></bp-svg-icon>
</button>

<bp-current-subscription-management
	mode="upgrade"
	(subscriptionPlanSuccessfullyPurchased)="dialogRef.close(true)"
></bp-current-subscription-management>
